import React from 'react';
import BaseSkeleton from './BaseSkeleton';

const ProfilePageSkeleton = () => {
    return (
        <div className="p-4">
            <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-20 bg-gray-300 animate-pulse rounded-full" />
                <div className="flex-1 space-y-2">
                    <BaseSkeleton width="w-32" height="h-5" />
                    <BaseSkeleton width="w-48" height="h-4" />
                </div>
            </div>
            <div className="grid grid-cols-1 gap-5">
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="space-y-2">
                        <BaseSkeleton width="w-24" height="h-4" />
                        <BaseSkeleton width="w-full" height="h-12" rounded="rounded-md" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProfilePageSkeleton;